export const unsecuredLenderNames: string[] = [
    '118 Money',
    'AA Loans',
    'Abound',
    'Admiral',
    'Alphera',
    'Amazon',
    'American Express (AMEX)',
    'AO',
    'Aqua',
    'Argos',
    'Asda Money',
    'Bamboo',
    'Bank of Scotland',
    'Barclaycard',
    'Barclays',
    'Better Borrow',
    'Bip',
    'Black Horse',
    'BMW',
    'Capital One',
    'Close Brothers',
    'Clydesdale',
    'Creation',
    'Currys',
    'Debenhams',
    'Everyday Loans',
    'First Direct',
    'Fluid',
    'Freemans',
    'Halifax',
    'Hastings Direct',
    'Home Retail Group',
    'HSBC',
    'Ikano',
    'Jaja',
    'Jacamo',
    'JD Williams',
    'John Lewis',
    'Kia Finance',
    'Klarna',
    'La Redoute',
    'Lendable',
    'Lloyds Bank',
    'M&S Bank',
    'Marbles',
    'MBNA',
    'Monzo',
    'Motonovo',
    'My Community Bank',
    'Nationwide Building Society',
    'Natwest',
    'NewDay',
    'Next',
    'Novuna (Formerly Hitachi)',
    'Onmo',
    'Oodle Car Finance',
    'Oplo',
    'Paypal',
    'Plata',
    'Post Office',
    'Pulse',
    'Ratesetter',
    'RBS',
    `Sainsbury's`,
    'Santander',
    'Shawbrook',
    'Shop Direct',
    'Simply Be',
    'Student loan',
    'Studio',
    'Tandem Bank',
    'Tesco Bank',
    'TSB',
    'V12 Finance',
    'Vanquis Bank',
    'Very',
    'Virgin Money',
    'Zable',
    'Zopa',
    'Other',
];
